import React from 'react';
import AircallCallButton from '../../../../components/AircallCallButton';

const CallsPanel = ({ expedientId, debtorId, debtor }) => {
  return (
    <div className='p-6'>
      <AircallCallButton expedientId={expedientId} debtorId={debtorId} />
    </div>
  );
};

export default CallsPanel;
